import { errorCodes, getUserFriendlyErrorMessage } from '../../utils/errormessages'
import { LOGOUT } from '../../app/authState'
import {
  CREATE_NEW_MEMBER_ADMIN,
  CREATE_NEW_MEMBER_ADMIN_ERROR,
  CREATE_NEW_MEMBER_ADMIN_SUCCESS,
  CREATE_NEW_MEMBER_PROVIDER,
  CREATE_NEW_MEMBER_PROVIDER_ERROR,
  CREATE_NEW_MEMBER_PROVIDER_SUCCESS,
  EDIT_ADMIN_MEMBER,
  EDIT_ADMIN_MEMBER_ERROR,
  EDIT_ADMIN_MEMBER_SUCCESS,
  EDIT_PROVIDER_MEMBER,
  EDIT_PROVIDER_MEMBER_ERROR,
  EDIT_PROVIDER_MEMBER_SUCCESS,
  RESET_NEW_MEMBER_PAGE,
  SET_ADMIN_PROFILE_IMG,
  SET_ADMIN_PROFILE_IMG_ERROR,
  SET_ADMIN_PROFILE_IMG_SUCCESS,
  SET_EDITED_ADMIN_MEMBER_DATA_VALUE,
  SET_EDITED_PROVIDER_MEMBER_DATA_VALUE,
  SET_IS_USER_DATA_CHANGED_VALUE,
  SET_NEW_MEMBER_PAGE_ERROR,
  SET_PAGE_STATUS,
  SET_PROVIDER_PROFILE_IMG,
  SET_PROVIDER_PROFILE_IMG_ERROR,
  SET_PROVIDER_PROFILE_IMG_SUCCESS,
  VALIDATE_PHONE_NUMBER,
  VALIDATE_PHONE_NUMBER_ERROR,
  VALIDATE_PHONE_NUMBER_SUCCESS,
} from './newMemberConstants'
import { apiErrorCodes } from '../../utils/apiHelper'
import { VISIT_TYPE } from '../../utils/constants'

const initialState = {
  pageState: 'idle',
  error: '',
  defaultServerErrorMessage: '',
  newAdminMemberId: '',
  newProviderMemberId: '',
  isUserDataChanged: false,
  duplicateLicensesInfo: {},
  phoneIsValid: null,
  editedAdminMemberData: null,
  editedProviderMemberData: null,
}

export default function newMemberReducer(state = initialState, action = {}) {
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  switch (action.type) {
    case CREATE_NEW_MEMBER_ADMIN:
    case CREATE_NEW_MEMBER_PROVIDER:
    case EDIT_ADMIN_MEMBER:
    case SET_ADMIN_PROFILE_IMG:
    case SET_PROVIDER_PROFILE_IMG:
    case EDIT_PROVIDER_MEMBER:
      return {
        ...state,
        pageState: 'loading',
      }
    case VALIDATE_PHONE_NUMBER:
      return {
        ...state,
        pageState: 'loading',
        phoneIsValid: null,
      }
    case VALIDATE_PHONE_NUMBER_SUCCESS:
      return {
        ...state,
        pageState: 'idle',
        phoneIsValid: true,
      }
    case CREATE_NEW_MEMBER_ADMIN_SUCCESS:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        newAdminMemberId: action.payload.UserId,
        newProviderMemberId: '',
      }
    case SET_PAGE_STATUS:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        pageState: action.payload,
      }
    case SET_IS_USER_DATA_CHANGED_VALUE:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isUserDataChanged: action.payload,
      }
    case SET_EDITED_ADMIN_MEMBER_DATA_VALUE:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        editedAdminMemberData: action.payload,
      }
    case SET_EDITED_PROVIDER_MEMBER_DATA_VALUE:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        editedProviderMemberData: action.payload,
      }
    case EDIT_ADMIN_MEMBER_SUCCESS:
      return {
        ...state,
        newAdminMemberId: '',
        newProviderMemberId: '',
        isUserDataChanged: true,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        editedAdminMemberData: action.payload.data,
      }
    case EDIT_PROVIDER_MEMBER_SUCCESS:
      return {
        ...state,
        newAdminMemberId: '',
        isUserDataChanged: true,
        newProviderMemberId: '',
        duplicateLicensesInfo: '',
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        editedProviderMemberData: action.payload.data,
      }
    case CREATE_NEW_MEMBER_PROVIDER_SUCCESS:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        newProviderMemberId: action.payload.UserId,
        newAdminMemberId: '',
        duplicateLicensesInfo: '',
      }
    case SET_ADMIN_PROFILE_IMG_SUCCESS:
      return {
        ...state,
        pageState: 'success',
        newAdminMemberId: '',
        newProviderMemberId: '',
        duplicateLicensesInfo: '',
        // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
        editedAdminMemberData: { ...state.editedProviderMemberData, ...action.payload.data },
      }
    case SET_PROVIDER_PROFILE_IMG_SUCCESS:
      return {
        ...state,
        pageState: 'success',
        newAdminMemberId: '',
        newProviderMemberId: '',
        duplicateLicensesInfo: '',
        // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
        editedProviderMemberData: { ...state.editedProviderMemberData, ...action.payload.data },
      }
    case SET_NEW_MEMBER_PAGE_ERROR:
    case CREATE_NEW_MEMBER_ADMIN_ERROR:
    case EDIT_ADMIN_MEMBER_ERROR:
    case EDIT_PROVIDER_MEMBER_ERROR:
    case SET_ADMIN_PROFILE_IMG_ERROR:
    case SET_PROVIDER_PROFILE_IMG_ERROR:
    case VALIDATE_PHONE_NUMBER_ERROR:
    case CREATE_NEW_MEMBER_PROVIDER_ERROR: {
      let message = ''
      let defaultServerErrorMessage = ''
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (action.payload.UserFriendlyErrorCode || action.payload.UserFriendlyErrorCode === '') {
        message =
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          action.payload.UserFriendlyErrorCode ?
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            getUserFriendlyErrorMessage(action.payload.UserFriendlyErrorCode, null, action.payload.extra)
          : ''
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        defaultServerErrorMessage = action.payload.UserFriendlyErrorCode ? action.payload : ''
      } else {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        switch (action.payload.ErrorCode) {
          case apiErrorCodes.PHONE_NUMBER_NOT_VALID:
            return {
              ...state,
              pageState: 'idle',
              phoneIsValid: false,
            }
          case apiErrorCodes.THIRD_PARTY_ERROR:
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            const { ErrorCode, ErrorMessage } = action.payload.Data
            message = `${ErrorCode} - ${ErrorMessage}`
            return {
              ...state,
              pageState: 'idle',
              error: message,
              phoneIsValid: false,
            }
          case apiErrorCodes.PHONE_NUMBER_NOT_UNIQUE:
            return {
              ...state,
              pageState: 'idle',
              error: getUserFriendlyErrorMessage(errorCodes.PROVIDER_NUMBER_NOT_UNIQUE),
            }
          case 'EmailNotValid':
            message = getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, 'Email')
            break
          case 'LicenseNotUnique':
            return {
              ...state,
              error: getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS, null),
              pageState: 'idle',
              duplicateLicensesInfo: {
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                licenseNumber: action.payload.Data.Number,
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                stateCode: action.payload.Data.StateCode,
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                licensedBy: action.payload.Data.LicensedBy,
              },
            }
          case 'FirstNameNotValid':
            message = getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, 'First name')
            break
          case apiErrorCodes.LICENSE_VISIT_TYPE_COUNT_NOT_VALID:
            message = getUserFriendlyErrorMessage(errorCodes.LICENSE_WITHOUT_ONE_SERVICE_TYPE, null)
            break
          case apiErrorCodes.VISIT_TYPE_NOT_FOUND:
            message = getUserFriendlyErrorMessage(errorCodes.ITEM_DOES_NOT_EXIST, null, VISIT_TYPE)
            break
          case 'LastNameNotValid':
            message = getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, 'Last name')
            break
          case 'EmailNotUnique':
            message = getUserFriendlyErrorMessage(errorCodes.NAME_ALREADY_EXISTS, null, 'Email')
            break
          case 'EmailCannotBeModified':
            message = getUserFriendlyErrorMessage(errorCodes.ALREADY_ACTIVATED_USER, null)
            break
          case 'InternalServerError':
            message = getUserFriendlyErrorMessage(errorCodes.DEFAULT)
            break
          default:
            message = getUserFriendlyErrorMessage(errorCodes.DEFAULT)
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            defaultServerErrorMessage = action.payload
            break
        }
      }
      return {
        ...state,
        error: message,
        pageState: 'idle',
        defaultServerErrorMessage,
      }
    }
    case RESET_NEW_MEMBER_PAGE:
    case LOGOUT:
      return {
        ...initialState,
      }
    default:
      return state
  }
}
